// extracted by css-extract-rspack-plugin
export default {"templafyIconLandscape":"templafyIconLandscape-aiaMwL","templafyIconPortrait":"templafyIconPortrait-DkDqTr"};